import * as React from 'react'
import type { SVGProps } from 'react'
const SvgTonIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={11}
    viewBox="0 0 12 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.41385 0.0428467H2.58468C1.32903 0.0428467 0.533177 1.39731 1.16489 2.49228L5.37961 9.79756C5.65464 10.2746 6.34389 10.2746 6.61893 9.79756L10.8345 2.49228C11.4654 1.39906 10.6695 0.0428467 9.41471 0.0428467H9.41385ZM5.37618 7.60681L4.45828 5.83035L2.2435 1.86917C2.09739 1.61563 2.27786 1.29074 2.58382 1.29074H5.37532V7.60767L5.37618 7.60681ZM9.75332 1.86831L7.53939 5.8312L6.6215 7.60681V1.28988H9.413C9.71896 1.28988 9.89943 1.61478 9.75332 1.86831Z"
      fill="#2E2F40"
    />
  </svg>
)
export default SvgTonIcon
